import * as React from 'react';
import { Dispatch, Action } from 'redux';
import SettingPopup from '../common/SettingPopup';
import { connect } from 'react-redux';
import { AppStates } from '../../reducers/app';
import { setTTSTracking } from '../../actions/PreferenceAction';

interface MiscSettingProps {
  readonly isOpen: boolean;
  readonly ttsTracking: boolean;
  readonly dispatch: Dispatch<Action>;
  readonly onClose: () => void;
}

const wrapperStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
};

const titleStyle: React.CSSProperties = {
  width: '300px',
  padding: '1em',
};

const checkBoxStyle: React.CSSProperties = {
  display: 'block',
  flex: 0,
  margin: '1em',
};

const hairLineStyle: React.CSSProperties = {
  height: 0,
  margin: 0,
};

const MiscSetting: React.FC<MiscSettingProps> | null = (props) => {
  const { isOpen, dispatch } = props;

  if (!isOpen) {
    return null;
  }

  // FIXME: 仮UI
  return (
    <SettingPopup title="各種設定" onClose={props.onClose}>
      <div style={wrapperStyle}>
        <label
          htmlFor="ttsTracking"
          style={titleStyle}>
          読み上げ位置に追従
        </label>
        <input
          id="ttsTracking"
          type="checkbox"
          style={checkBoxStyle}
          defaultChecked={props.ttsTracking}
          onChange={(ev) => {
            dispatch(setTTSTracking(ev.target.checked));
          }}
        />
      </div>

      <hr style={hairLineStyle} />

      {/* DUMMY */}
      <div style={wrapperStyle}>
        <label
          htmlFor="enablePanningOnlyIfZoomed"
          style={titleStyle}>
          ズーム中のみページをスクロール
        </label>
        <input
          id="enablePanningOnlyIfZoomed"
          type="checkbox"
          style={checkBoxStyle}
        />
      </div>
    </SettingPopup>
  );
};

const mapStateToProps = (state: AppStates) => {
  const { ttsTracking } = state.preference;
  return { ttsTracking };
};

export default connect(mapStateToProps)(MiscSetting);
